import React from 'react';
// Components
import Header from '../header';
import Footer from '../footer';
import Cookies from '../cookies';
import Seo from '../seo';

// Interfaces
import { Cookies as CookiesInterface } from '../../interfaces/cookies';
import { Menu as MenuInterface } from '../../interfaces/menu';
import { Footer as FooterInterface } from '../../interfaces/footer';
import { Seo as SeoInterface } from '../../interfaces/seo';

import { LanguageProvider } from '../state/';

interface PageProps {
  pageId?: string;
  locale: string;
  seo?: SeoInterface;
  cookies?: CookiesInterface;
  menu: MenuInterface;
  footer: FooterInterface;
  children: Array<JSX.Element> | JSX.Element;
  pageNavigation?: boolean;
}

function MainLayout(props: PageProps) {
  const { menu, pageId, locale, footer, cookies, seo, children, pageNavigation } = props;

  return (
    <LanguageProvider value={locale}>
      <main>
        {seo && (
          <Seo
            seo={{
              title: seo.title,
              ogtitle: seo.ogtitle,
              description: seo.description,
              ogdescription: seo.ogdescription,
              ogtype: 'article',
              locale,
              image: {
                file: {
                  url: seo.image.file.url,
                },
              },
              keywords: seo.keywords,
              robots: seo.robots,
              revisitAfter: seo.revisitAfter,
            }}
          />
        )}

        {(pageNavigation || pageNavigation === null) && (
          <Header menuItems={menu} pageId={pageId} locale={locale} />
        )}

        {children}

        {(pageNavigation || pageNavigation === null) && <Footer footerContent={footer} />}
        {/* {cookies && <Cookies cookiesData={cookies} />} */}
      </main>
    </LanguageProvider>
  );
}

export default MainLayout;
